<template>
  <div class="match-card">
    <v-toolbar height="40" class="lighten-3 pr-0 pl-0" flat>
      <div class="match-title">
        <v-icon small left class="icon-color">{{
          categoryText | getIcon
        }}</v-icon>
        <v-toolbar-title class="body-2 white--text text-uppercase">
          {{ category === 'Football' ? 'Soccer' : category }}
        </v-toolbar-title>
      </div>
      <div class="match-bet-section">
        <v-sheet
          :class="{
            'odds-title-width-smAndUp': !xsVersion && $breakpoint.smAndUp,
            'odds-title-width-xs': xsVersion || $breakpoint.xsOnly
          }"
        >
          <v-row no-gutters>
            <v-col cols="4" class="text-center caption">1</v-col>

            <v-col cols="4" class="text-center caption">X</v-col>

            <v-col cols="4" class="text-center caption">2</v-col>
          </v-row>
        </v-sheet>
      </div>
    </v-toolbar>
  </div>
</template>
<script>
export default {
  name: 'InplayTitle',

  props: {
    category: { type: String, default: '', required: true },
    categoryText: { type: String, default: '', required: true },
    xsVersion: { type: Boolean, default: false, required: false }
  }
}
</script>
<style scoped>
.match-card {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.match-title {
  display: flex;
  align-items: center;
  width: 45%;
  background: var(--v-primary-base);
  height: 40px;
  padding-left: 10px;
}
.white--text .icon-color {
  color: #fff;
}
.icon-color {
  color: #fff;
}
.match-bet-section {
  width: 55%;
  display: flex;
  background-image: linear-gradient(to right, #222 50%, #444);
  height: 40px;
  align-items: center;
  justify-content: center;
}
.playing-title .match-bet-section {
  border-top-right-radius: 20px !important;
}
.playing-title .match-title {
  border-top-left-radius: 20px !important;
}
.upcoming-play .match-card:first-child .match-title {
  border-top-left-radius: 20px !important;
}
.upcoming-play .match-card:first-child .match-bet-section {
  border-top-right-radius: 20px !important;
}
.v-sheet {
  color: #fff;
  height: 40px;
  background-image: linear-gradient(to right, #000 50%, #444);
}
.row.no-gutters > .col,
.row.no-gutters > [class*='col-'] {
  padding: 0;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.v-sheet {
  border-top-right-radius: 20px !important;
}
@media (min-width: 600px) and (max-width: 959px) {
  .match-title {
    width: 50%;
  }
  .match-bet-section {
    width: 50%;
  }
}
@media (min-width: 959px) and (max-width: 1600px) {
  .match-title {
    width: 68%;
  }
  .match-bet-section {
    width: 32%;
  }
}
</style>
